import { useState } from "preact/hooks";
import { useAuth } from "../lib/auth";

export function SignIn() {
  const auth = useAuth();
  const [mode, setMode] = useState<"signin" | "magic">("signin");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [sent, setSent] = useState(false);

  return (
    <main class="app-main narrow" style="max-width: 24rem; margin: 2rem auto;">
      <h1 style="font-size: var(--fs-32); font-weight: 600;">Stash</h1>
      <p class="muted" style="margin-top: 0;">A calm place to read.</p>

      {auth.error && <div class="banner error">{auth.error}</div>}
      {sent && (
        <div class="banner ok">
          Check your inbox for a magic link.
        </div>
      )}

      {mode === "signin" ? (
        <form
          class="col"
          onSubmit={async (e) => {
            e.preventDefault();
            await auth.signInWithEmail(email, password);
          }}
        >
          <div class="field">
            <label for="email">Email</label>
            <input id="email" type="email" required value={email}
              onInput={(e) => setEmail((e.target as HTMLInputElement).value)}
              placeholder="you@example.com" autocomplete="email" />
          </div>
          <div class="field">
            <label for="password">Password</label>
            <input id="password" type="password" required value={password}
              onInput={(e) => setPassword((e.target as HTMLInputElement).value)}
              autocomplete="current-password" />
          </div>
          <button class="primary" type="submit">Sign in</button>
          <button class="ghost" type="button"
            onClick={() => auth.signUpWithEmail(email, password).then(() => setSent(true))}>
            Create account with these credentials
          </button>
          <button class="ghost" type="button" onClick={() => setMode("magic")}>
            Use a magic link instead
          </button>
          <button class="ghost" type="button" onClick={() => auth.signInWithGoogle()}>
            Continue with Google
          </button>
        </form>
      ) : (
        <form
          class="col"
          onSubmit={async (e) => {
            e.preventDefault();
            await auth.signInWithMagic(email);
            setSent(true);
          }}
        >
          <div class="field">
            <label for="m-email">Email</label>
            <input id="m-email" type="email" required value={email}
              onInput={(e) => setEmail((e.target as HTMLInputElement).value)}
              placeholder="you@example.com" autocomplete="email" />
          </div>
          <button class="primary" type="submit">Send magic link</button>
          <button class="ghost" type="button" onClick={() => setMode("signin")}>
            Back to password sign-in
          </button>
        </form>
      )}
    </main>
  );
}
